import React from 'react'
import PropTypes from 'prop-types'

import '@loyal_template/search.css'
import productPlaceholder from '@loyal_images/products/product_placeholder.png'

const bgBanner = {
  backgroundColor: '#D2DCDE'
}

const verifyVendor = vendor => {
  if (vendor) {
    return vendor.length > 0 && vendor[0].imageUrl
  }

  return productPlaceholder
}

const StoreInfo = ({ vendors, isLoading }) => {
  return (
    <div className='container-fluid container-results mb-3'>
      <div className='row'>
        <div className='col-12 px-0'>
          <div className='row py-2 innerShadow' style={bgBanner}>
            <div className='col-12 px-0 py-5' />
          </div>
          <div className='row bg-transparent'>
            <div className='container  pos-relative py-1 px-2'>
              <div className='row pos-relative'>
                <div className='thumbStore col-auto d-none d-lg-flex py-half px-half border border-color-ui-3 bg-white'>
                  <div className='row  align-items-center h-100'>
                    <div className='col'>
                      <img
                        className='radius d-block mx-auto'
                        src={`${isLoading ? productPlaceholder : vendors && vendors.length > 0 ? verifyVendor(vendors) : productPlaceholder}`}
                        alt={`${productPlaceholder ? 'Carregando...' : vendors && vendors.length > 0 && vendors[0].name}`}
                      />
                    </div>
                  </div>
                </div>
                <div className='offset-0 offset-lg-2 col-12 col-lg pos-relative'>
                  {isLoading
                    ? <h2 className='titleStore col-5 pt-1 bg-ui-5 radius' />
                    : <h2 className='titleStore color-ui-white l-0 w-100 txt-center txt-lg-left'>
                      {vendors && vendors.length > 0 && vendors[0].name}
                    </h2>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

// schema
StoreInfo.propTypes = {
  vendors: PropTypes.object.isRequired,
  isLoading: PropTypes.bool
}

export default StoreInfo



// WEBPACK FOOTER //
// ./src/Catalog/Search/StoreInfo.js